import Wizard from '/components/Wizard';

class WizardAPI {
  wizard = Wizard.create();
  init = (...args) => this.wizard.init(...args);
}

export default new WizardAPI();
